import {CustomAlertsCountResults} from 'app_api/projects/alerts/custom/types';
import {ApiSingleValueResource} from 'common/util/model-resource/api-resource';

import {customAlertsLimitClient} from '../queries/app-api/custom-alerts-limit-client';
import {getProjectId} from '../util';

export class AlertLimitsResource extends ApiSingleValueResource<CustomAlertsCountResults> {
  apiClient = customAlertsLimitClient;

  constructor({projectId = null, urlManager = null} = {}) {
    super();
    this.id = projectId ?? getProjectId(urlManager);
  }
}
